<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card flat class="mt-5" v-else>
      <v-row class="ml-1 mt-3 mb-n3">
        <v-col cols="12" sm="12" xl="3" xs="12" lg="3" md="3">
          <v-select
            label="Select card Type"
            outlined
            dense
            item-text="name"
            item-value="value"
            v-model="statusfilter"
            :items="statusfilteroptions"
            class="mr-2"
            return-object
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" xl="3" xs="12" lg="3" md="3">
          <v-select
            v-model="statusType"
            :items="listStatus"
            item-text="name"
            item-value="value"
            dense
            outlined
            label="Status"
            class="mr-2"
          ></v-select>
        </v-col>
        <!-- :items="statusfilteroptions" -->
        <v-card-actions>
          <v-btn
            small
            fab
            text
            @click="callfilter()"
            color="dark"
            class="elevation-0 mb-6"
          >
            <v-icon dark>mdi-filter</v-icon>
          </v-btn>
        </v-card-actions>
      </v-row>
      <v-data-table
        :headers="statusheader"
        dense
        :items="statusitem"
        :options.sync="pagination"
        :items-per-page="itemsPerPage"
        @update:options="getCardStatusPagination()"
        :no-data-text="Nodata"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ statusitem.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.quantity_description`]="{ item }">
          <span class="caption">{{ item.quantity_description }}</span>
        </template>

        <template v-slot:[`item.pack_code`]="{ item }">
          <span class="caption" v-if="item.pack_code != null">{{
            item.pack_code
          }}</span>
          <span class="caption" v-else>-</span>
        </template>
        <template v-slot:[`item.pack_name`]="{ item }">
          <span class="caption">{{ item.pack_name }}</span>
        </template>
        <template v-slot:[`item.requested_date`]="{ item }">
          <span class="caption">{{ item.requested_date }}</span>
        </template>
        <template v-slot:[`item.admin_approval_date`]="{ item }">
          <span class="caption" v-if="item.admin_approval_date == null">-</span>
          <span class="caption" v-if="item.admin_approval_date != null">{{
            item.admin_approval_date
          }}</span>
        </template>
        <template v-slot:[`item.card_type`]="{ item }">
          <span class="caption" v-if="item.card_type == 1"
            >Non-Personalized</span
          >
          <span class="caption" v-if="item.card_type == 2">Personalized</span>
        </template>
        <template v-slot:[`item.awb_number`]="{ item }">
          <span class="caption">{{ item.awb_number }}</span>
        </template>
        <template v-slot:[`item.dispatched_date`]="{ item }">
          <span class="caption" v-if="item.dispatched_date != null">{{
            item.dispatched_date
          }}</span>
          <span class="caption" v-if="item.dispatched_date == null">-</span>
        </template>
        <template v-slot:[`item.View`]="{ item }">
          <span>
            <v-icon
              small
              class="ml-2"
              @click="showContent(item)"
              v-on="on"
              color="primary"
              >mdi-eye</v-icon
            ></span
          >
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <div
            class="orangecolor caption"
            @click="acknolageMe(item)"
            v-if="item.status === 'Dispatched'"
          >
            {{ item.status }}
          </div>
          <div
            v-else-if="item.status === 'Approved'"
            class="caption green--text"
          >
            {{ item.status }}
          </div>
          <div
            v-else-if="item.status === 'Pending For Approval'"
            class="caption blue--text"
          >
            {{ item.status }}
          </div>
          <div v-else-if="item.status === 'Rejected'" class="caption red--text">
            {{ item.status }}
          </div>
          <div
            v-else-if="item.status === 'Payment failed'"
            class="caption red--text"
          >
            {{ item.status }}
          </div>
        </template>
      </v-data-table>
      <v-dialog v-model="contentDialog" width="400">
        <v-card>
          <v-toolbar flat class="header" dense dark>
            <v-icon>mdi-clipboard-text</v-icon>
            <span class="ml-3">Pack Details</span>
            <v-spacer></v-spacer>
            <v-btn class text dark @click="contentDialog = false">
              <v-icon color="white" small class="ml-8">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-card elevation="1" shaped class="mt-7 ml-5 mr-5 mb-3">
              <v-row>
                <v-col cols="12" md="12" lg="12">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Pack Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.pack_name != null"
                      >
                        {{ contentDetails.pack_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Pack Code</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.pack_code != null"
                      >
                        {{ contentDetails.pack_code }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>

                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Number Of Cards</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.quantity_description != null"
                      >
                        {{ contentDetails.quantity_description }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Amount</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.amount != null"
                      >
                        {{ contentDetails.amount }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <Acknowledge ref="acknowledge" v-on:backChild="actionFromChild" />
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>
<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";
import Acknowledge from "@/Views/users/acknowledge.vue";
export default {
  props: {
    tab: Number,
  },
  components: {
    Acknowledge,
    OverleyProccessg,
  },
  data: () => ({
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    checkaccessdata: {},

    count: 0,
    overlay: false,
    statusheader: [],
    contentDialog: false,
    contentDetails: {},
    on: "",
    statusheader1: [
      {
        text: "PACK CODE",
        value: "pack_code",
      },
      {
        text: "CARD PACK NAME",
        value: "pack_name",
      },
      {
        text: "REQUESTED DATE",
        value: "requested_date",
      },
      {
        text: "APPROVAL DATE",
        value: "admin_approval_date",
      },
      // {
      //   text: "AWB Number",
      //   value: "awb_number",
      // },
      {
        text: "CARD TYPE",
        value: "card_type",
      },
      // {
      //   text: "Dispatched Date",
      //   value: "dispatched_date",
      // },
      {
        text: "STATUS",
        value: "status",
      },
    ],
    statusfilter: 2,
    statusfilteroptions: [
      { name: "Personalized", value: 2 },
      { name: "Non Personalized", value: 1 },
    ],
    statusitem: [],
    Nodata: "",
    statusType: 3,
    listStatus: [
      {
        name: "All",
        value: 3,
      },
      {
        name: "Pending",
        value: 0,
      },
      {
        name: "Approved",
        value: 1,
      },
    ],
    statusvalue: "",
  }),
  watch: {
    tab(val) {
      console.warn("tab", val);
      this.getCardStatus(this.statusfilter);
    },
  },
  created() {
    this.checkaccess();
  },
  methods: {
    callfilter() {
      //  console.log("stat", stat);
      // var new_value = stat.value;
      this.getCardStatus(this.statusfilter);
    },
    actionFromChild() {
      this.getCardStatus(this.statusfilter);
    },
    convertDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async getCardStatusPagination() {
      if (this.statusitem.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "CARDS",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "CAREQS",
            corp_id: this.$store.getters.get_corpid,
            search_text: "",
            card_type:
              this.statusfilter == 2
                ? this.statusfilter
                : this.statusfilter.value,
            status: this.statusType == "" ? 0 : this.statusType,
          },
        };

        var responseData = await apiCall(inputData);

        this.statusitem = this.statusitem.concat(responseData.data.data);
      }
    },
    async getCardStatus(statusfilter) {
      this.count += 1;
      //console.log("this.statusfilter.value", this.statusfilter);
      this.overlay = true;
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "CAREQS",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
          card_type: statusfilter == 2 ? statusfilter : this.statusfilter.value,
          status: this.statusType == "" ? 0 : this.statusType,
        },
      };
      var responseData = await apiCall(inputData);
      if (this.count != 0) {
        if (this.statusfilter.value == 1) {
          this.statusheader = [
            { text: "SL NO", value: "sl_no", width: "50px", sortable: false },
            {
              text: "CARD PACK NAME",
              value: "pack_name",
              width: "50px",
              sortable: false,
            },
            {
              text: "PACK CODE",
              value: "pack_code",
              width: "50px",
              sortable: false,
            },
            {
              text: "REQUESTED DATE",
              value: "requested_date",
              width: "50px",
              sortable: false,
            },
            {
              text: "APPROVAL DATE",
              value: "admin_approval_date",
              width: "20px",
              sortable: false,
            },
            {
              text: "AWB NUMBER",
              value: "awb_number",
              width: "20px",
              sortable: false,
            },
            {
              text: "CARD TYPE",
              value: "card_type",
              width: "50px",
              sortable: false,
            },
            {
              text: "DISPATCHED DATE",
              value: "dispatched_date",
              width: "20px",
              sortable: false,
            },
            {
              text: "STATUS",
              value: "status",
              width: "50px",
              sortable: false,
            },
            {
              text: "VIEW",
              value: "View",
              width: "50px",
              sortable: false,
            },
          ];
        } else {
          this.statusheader = [
            { text: "SL NO", value: "sl_no" },
            {
              text: "PACK CODE",
              value: "pack_code",
            },
            {
              text: "CARD PACK NAME",
              value: "pack_name",
            },
            {
              text: "REQUESTED DATE",
              value: "requested_date",
            },
            {
              text: "APPROVAL DATE",
              value: "admin_approval_date",
            },
            {
              text: "CARD TYPE",
              value: "card_type",
            },
            {
              text: "STATUS",
              value: "status",
            },
            {
              text: "VIEW",
              value: "View",
              width: "50px",
            },
          ];
        }

        if (responseData.data.status == "00") {
          this.statusitem =
            responseData.data.data == null ? [] : responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        } else if (responseData.data.status == "NOREC") {
          this.statusitem = [];
          this.Nodata = responseData.data.status_msg;
        }
        for (const items of this.statusitem) {
          this.statusvalue = items.status;
          // console.log(this.statusvalue);
          if (this.statusvalue == "Pending For Approval") {
            this.$emit("backchild");
          } else if (this.statusvalue == "Rejected") {
            this.$emit("backchild");
          } else if (this.statusvalue == "Approved") {
            this.$emit("backchild");
          }
        }

        this.overlay = false;
        //  console.log("responseData.data.data", responseData);
      }
    },
    acknolageMe(items) {
      this.$refs.acknowledge.ackdialog = true;
      this.$refs.acknowledge.itemsProxy = items;
      this.$refs.acknowledge.acknowledge();
    },
    showContent(item) {
      this.contentDialog = true;
      this.contentDetails = item;
      // console.log(" this.contentDetails", this.contentDetails);
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);

      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            break;
          case "CARDS":
            this.cardcount = responseData.data.data[i].count;
            this.$store.commit("SET_Requestcards", this.cardcount);
            break;
        }
      }
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getCardStatus(this.statusfilter);
      }
    },
  },
};
</script>
